import { render, staticRenderFns } from "./ShareDesc.vue?vue&type=template&id=03127711&scoped=true"
import script from "./ShareDesc.vue?vue&type=script&lang=js"
export * from "./ShareDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03127711",
  null
  
)

export default component.exports